import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardMessageOption')(function discardMessageOption(state) {
    var optionState = state.optionState;
    optionState.emptyDeletedItemsOnLogOut = null;
}));
//# sourceMappingURL=discardMessageOption.js.map